import analytics from '@banking/ui/workflows/utils/analytics';
import events from '@banking/ui/workflows/card-settings/cancel-card/analytics/cancel-card-events';
export default analytics([...events]);